import type { TextVariants } from '@/components/text';

export type RadioButtonOption = {
  id: string;
  name: string;
  description?: string;
  disabled?: boolean;
  image?: {
    src: string;
    alt: string;
  };
};

export enum RadioButtonVariant {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum RadioButtonOrientation {
  ROW = 'row',
  COLUMN = 'column',
}

export type RadioButtonProps = {
  option: RadioButtonOption;
  variant?: RadioButtonVariant;
};

export type RadioButtonGroupProps = {
  name?: string;
  heading?: string;
  showHeading?: boolean;
  headingVariant?: TextVariants['variant'];
  options: RadioButtonOption[];
  selected?: string;
  variant?: RadioButtonVariant;
  orientation?: RadioButtonOrientation;
  disabled?: boolean;
  onChange: (val: string) => void;
  withImages?: boolean;
  required?: boolean;
  subheading?: string;
};
